import { differenceInDays, parseISO, isValid } from 'date-fns';

const convertToISO = (dateStr) => {
  if (!dateStr || typeof dateStr !== 'string') return '';
  const [dd, mm, yyyy] = dateStr.split("-");
  return `${yyyy}-${mm}-${dd}`;
};

export const getFilterOptions = (formattedStart, formattedEnd, component) => {
  const options = [];

  const startDateStr = typeof formattedStart === 'string' ? convertToISO(formattedStart) : formattedStart;
  const endDateStr = typeof formattedEnd === 'string' ? convertToISO(formattedEnd) : formattedEnd;

  const start = typeof startDateStr === 'string' ? parseISO(startDateStr) : startDateStr;
  const end = typeof endDateStr === 'string' ? parseISO(endDateStr) : endDateStr;

  if (!isValid(start) || !isValid(end)) {
    console.warn("Invalid start or end date passed to getFilterOptions:", formattedStart, formattedEnd);
    return options;
  }

  const diffDays = differenceInDays(end, start);

  if (diffDays >= 0) {
    if(component == "times-sales"){
      options.push({ label: 'Hourly', value: 'hourly' });
      options.push({ label: 'Time Of Day', value: 'dayparts' });
    }else{
      options.push({ label: 'Daily', value: 'daily' });
    }
  }
  if (diffDays >= 7) {
    options.push({ label: 'Weekly', value: 'weekly' });
  }
  if (diffDays >= 30) {
    options.push({ label: 'Monthly', value: 'monthly' });
  }
  if (diffDays >= 90) {
    options.push({ label: 'Quarterly', value: 'quarterly' });
  }
  if (diffDays >= 365) {
    options.push({ label: 'Yearly', value: 'yearly' });
  }

  return options;
};
